(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/authorization/assets/javascript/constants.js') >= 0) return;  svs.modules.push('/modules/authorization/assets/javascript/constants.js');

'use strict';

var _svs;
const POST_MESSAGE_SOURCE = 'svs-iam-iframe';
const TARGET_ORIGIN = '*';
const TRUSTED_ORIGIN = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.authorization) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.origins) === null || _svs === void 0 ? void 0 : _svs.trusted;
const isInIamIframe = window.self !== window.top;
const POST_MESSAGE_TYPES = {
  HEIGHT: 'height',
  PARENT_REDIRECT: 'parent-redirect',
  PARENT_REDIRECT_POST: 'parent-redirect-post',
  SHOW_DIALOG: 'show-dialog',
  SHOW_DIALOG_RESOLVED: 'show-dialog-resolved',
  SHOW_DIALOG_EXTENDED: 'show-dialog-extended',
  SHOW_DIALOG_EXTENDED_RESOLVED: 'show-dialog-extended-resolved',
  PARENT_TRACK_EVENT: 'parent-track-event',
  PARENT_TRACK_EVENT_RESOLVED: 'parent-track-event-resolved'
};
svs.authorization.constants = {
  POST_MESSAGE_SOURCE,
  TARGET_ORIGIN,
  TRUSTED_ORIGIN,
  POST_MESSAGE_TYPES,
  isInIamIframe
};

 })(window);